/**
 * Typed environment helpers.
 * All VITE_* vars are bundled at build time - no runtime secrets here.
 */
// Prod deployment colocates storefront ('/') and dashboard ('/admin/') on the
// same Render static service - so dashboardUrl in prod is the same origin and
// we use a relative path. In dev (Vite), the dashboard runs on :5173.
const dashboardUrlDefault = import.meta.env.DEV
    ? 'http://localhost:5173'
    : ''; // same-origin in prod - DevOnlyGate uses '/admin/sign-in' as relative path
export const ENV = {
    /** Backend API base URL. MUST be set at build-time in prod via VITE_API_BASE_URL. */
    apiBaseUrl: import.meta.env.VITE_API_BASE_URL || 'http://localhost:3001',
    /** API path prefix, e.g. /api/v1 */
    apiPrefix: import.meta.env.VITE_API_PREFIX || '/api/v1',
    /** Dashboard origin for redirects. Same-origin in prod, localhost in dev. */
    dashboardUrl: import.meta.env.VITE_DASHBOARD_URL || dashboardUrlDefault,
    /** Google Maps JavaScript API key */
    googleMapsApiKey: import.meta.env.VITE_GOOGLE_MAPS_API_KEY || '',
};
